import { Component, Inject } from '@angular/core';
import { IvyModalOptions, IvyModalService } from '@crs/ivy';
import { TranslateService } from '@ngx-translate/core';
import { OKTA_AUTH } from '@okta/okta-angular';
import OktaAuth from '@okta/okta-auth-js';
import { UserIdleService } from 'angular-user-idle';
import { SessionTimeoutDialogComponent } from './common/session-timeout-dialog/session-timeout-dialog.component';
import { AppConfig } from 'src/app/app.config';

@Component({
  selector: 'app-root',
  standalone: false,
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  dialogOptions: IvyModalOptions = {
    allowCancel: true,
    size: 'md',
    backdrop: true,
  };
  constructor(@Inject(OKTA_AUTH) public oktaAuth: OktaAuth, translate: TranslateService, private userIdle: UserIdleService, private modalService: IvyModalService) {
    translate.addLangs([AppConfig.defaultLanguage]);
    translate.setDefaultLang(AppConfig.defaultLanguage);
    translate.use(AppConfig.defaultLanguage);

    //Start watching for user inactivity.
    this.userIdle.startWatching();

    // Start watching when user idle is starting.
    this.userIdle.onTimerStart().subscribe(count => count);

    // Start watch when time is up.
    this.userIdle.onTimeout().subscribe(() => {
      const ref = this.modalService.open(SessionTimeoutDialogComponent, this.dialogOptions);
      ref.result.then(
        (r) => {
          if(r === 'yes') {
            this.restart();
            this.startWatching();
          } else {
            this.oktaAuth.signOut();
          }
        },
        (e) => {
          this.restart();
          this.startWatching();
        }
      );
      this.stopWatching();
    });
  }

  stop() {
    this.userIdle.stopTimer();
  }

  stopWatching() {
    this.userIdle.stopWatching();
  }

  startWatching() {
    this.userIdle.startWatching();
  }

  restart() {
    this.userIdle.resetTimer();
  }
}